<template>
  <v-autocomplete
    v-model="select"
    :loading="loading"
    :item-value="itemValue"
    :item-text="itemText"
    :items="items"
    :search-input.sync="search"
    :disabled="disabled"
    outlined
    dense
    flat
    auto-select-first
    :allow-overflow="false"
    :hide-no-data="noData"
    hide-details
    @update:search-input="handleInput"
    @change="handleChange"
  ></v-autocomplete>
</template>

<script>
export default {
  name: 'Autocomplete',
  props: {
    itemValue: {
      type: String,
      default: 'id'
    },
    itemText: {
      type: String,
      default: 'name'
    },
    input: {
      type: String,
      default: ''
    },
    states: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      items: [],
      search: null,
      select: null,
      noData: false
    }
  },
  watch: {
    input (newVal) {
      this.select = newVal
    },
    states () {
      this.querySelections(this.search)
    },
    search (val) {
      val && val !== this.select && this.querySelections(val)
    }
  },
  methods: {
    querySelections (v) {
      this.loading = true
      this.noData = !this.states.length
      setTimeout(() => {
        this.items = this.states
          .filter(e => {
            return (e[this.itemText] || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
          })
        this.loading = false
      }, 500)
    },
    handleInput (input) {
      this.$emit('input', input)
    },
    handleChange (input) {
      if (input) { this.$emit('change', input) }
    }
  }
}
</script>
<style>
.theme--dark.v-list-item .v-list-item__mask {
  color: #ffffff;
  font-weight: 800;
  background: none;
}
.theme--light.v-list-item .v-list-item__mask {
  color: #000000;
  font-weight: 800;
  background: none;
}
</style>
